// extracted by mini-css-extract-plugin
module.exports = {"no-collection-name":"_11a6b"};